import { KeyOutlined } from '@mui/icons-material';
import { IntegrationSecret } from '@requests/secrets';
import { ListItemContainer, ListItemContent, ListItemProps } from './ListItem';
import { Stack } from '@mui/material';

type SecretItem = {
  id: string;
  label: string;
  value: IntegrationSecret;
  metadata: {
    group: string;
    key: string;
  };
};

export const SecretListItem: React.FC<ListItemProps<SecretItem>> = (props) => {
  const { option, key, ...liProps } = props;

  return (
    <ListItemContainer key={key || option.id} {...liProps}>
      <Stack>
        <KeyOutlined sx={{ fontSize: '20px' }} />
      </Stack>
      <ListItemContent>
        <h1>{option.label}</h1>
      </ListItemContent>
    </ListItemContainer>
  );
};
